<template>
  <require from="controls/bs-form-textarea"></require>
  <require from="controls/as-form-section.html"></require>
  <require from="controls/as-form-widget.html"></require>

  <as-form-section heading="Additional Details" intro="Please provide us with additional details of the requested deviation.">
    <div slot="body" class="as-widget-item deviation-request-info-panel">
      <as-form-widget icon="fas fa-info">
        <div slot="default">
          <div class="form-row">
            <div class="col-12">
              <bs-form-textarea label="Reason for Deviation" placeholder="Please enter the reason for deviation" value.bind="model.reason & validate:infoPanelRules" disabled.bind="disabled"></bs-form-textarea>
            </div>
            <div class="col-12">
              <bs-form-textarea label="Alternative Options" placeholder="Please enter alternative options" value.bind="model.alternativeOptions & validate:infoPanelRules" disabled.bind="disabled"></bs-form-textarea>
            </div>
            <div class="col-12">
              <bs-form-textarea label="Deviation Risk Management" placeholder="Please enter deviation risk management" value.bind="model.riskManagement & validate:infoPanelRules" disabled.bind="disabled"></bs-form-textarea>
            </div>
            <div class="col-12">
              <bs-form-textarea label="Additional Info" placeholder="You may enter additional info" value.bind="model.additionalInfo" disabled.bind="disabled"></bs-form-textarea>
            </div>
          </div>
        </div>
      </as-form-widget>
    </div>
  </as-form-section>
</template>
